const nextjsColorUrl = new URL(
  '../assets/images/icons/technologies/nextjs/nextjs_ico-color.svg',
  import.meta.url,
).href;
const nextjsWhiteUrl = new URL(
  '../assets/images/icons/technologies/nextjs/nextjs_ico-white.svg',
  import.meta.url,
).href;
const nextjsGrayUrl = new URL(
  '../assets/images/icons/technologies/nextjs/nextjs_ico-gray.svg',
  import.meta.url,
).href;
const nextjsBlackUrl = new URL(
  '../assets/images/icons/technologies/nextjs/nextjs_ico-black.svg',
  import.meta.url,
).href;

const rnColorUrl = new URL(
  '../assets/images/icons/technologies/reactnative/reactnative_ico-color.svg',
  import.meta.url,
).href;
const rnWhiteUrl = new URL(
  '../assets/images/icons/technologies/reactnative/reactnative_ico-white.svg',
  import.meta.url,
).href;
const rnGrayUrl = new URL(
  '../assets/images/icons/technologies/reactnative/reactnative_ico-gray.svg',
  import.meta.url,
).href;
const rnBlackUrl = new URL(
  '../assets/images/icons/technologies/reactnative/reactnative_ico-black.svg',
  import.meta.url,
).href;

export function getDocsImage(imageName: string): string {
  const images: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/docs/*.{webp,png,jpg,jpeg}',
    { eager: true },
  );

  return images[`/src/assets/images/docs/${imageName}`]?.default || '';
}

export function getProjectImage(
  imageName: string,
  projectName: string,
): string {
  const projectImages: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/projects/*/screens/*.{webp,png,jpg,jpeg}',
    { eager: true },
  );

  return (
    projectImages[
      `/src/assets/images/projects/${projectName}/screens/${imageName}`
    ]?.default || ''
  );
}

export function getProjectLogo(logoName: string, projectName: string): string {
  const projectLogos: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/projects/*/logos/*.{webp,png,jpg,jpeg}',
    { eager: true },
  );

  return (
    projectLogos[`/src/assets/images/projects/${projectName}/logos/${logoName}`]
      ?.default || ''
  );
}

export function getProjectPreviewVideo(
  videoName: string,
  projectName: string,
): string {
  const projectVideos: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/projects/*/videos/*.{mp4,webm,ogv,ogg}',
    { eager: true },
  );

  return (
    projectVideos[
      `/src/assets/images/projects/${projectName}/videos/${videoName}`
    ]?.default || ''
  );
}

export function getIcon(
  iconName: string,
  iconCategory: string,
  iconDesc: string,
): string {
  const rawIcons: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/icons/**/*.{svg,png,webp,jpg}',
    { eager: true },
  );
  const icons: Record<string, { default: string }> = Object.fromEntries(
    Object.entries(rawIcons).map(([key, val]) => [
      key.toLowerCase().replaceAll('\\', '/'),
      val,
    ]),
  );

  const normalizedDesc = iconDesc
    .toLowerCase()
    .replaceAll(' ', '')
    .replaceAll('-', '');
  const normalizedName = iconName.toLowerCase();
  const baseKey = `/src/assets/images/icons/${iconCategory}/${normalizedDesc}/${normalizedName}`;
  const direct = icons[baseKey]?.default || '';
  if (direct) return direct;
  const match = iconName.match(/^(.*_ico-)([^.]+)(\.[a-zA-Z0-9]+)$/);
  if (match) {
    const [, prefix, , suffix] = match;
    const colorOrder = ['color', 'white', 'gray', 'black'];
    for (const color of colorOrder) {
      const altName = `${prefix}${color}${suffix}`;
      const altKey = `/src/assets/images/icons/${iconCategory}/${normalizedDesc}/${altName}`;
      const found = icons[altKey]?.default;
      if (found) return found;
    }
  }

  const colorOrder = ['color', 'white', 'gray', 'black'];
  for (const color of colorOrder) {
    const candidate = Object.keys(icons).find((key) => {
      return (
        key.includes(`/icons/${iconCategory}/`) &&
        key.includes(`/${normalizedDesc}/`) &&
        key.endsWith(`/${normalizedDesc}_ico-${color}.svg`)
      );
    });
    if (candidate) {
      return icons[candidate].default;
    }
  }

  return '';
}

export function getLogo(
  logoName: string,
  logoCategory: string,
  logoDesc: string,
): string {
  const logos: Record<string, { default: string }> = import.meta.glob(
    '/src/assets/images/logos/*/*/*.{svg,png,webp,jpg}',
    { eager: true },
  );

  return (
    logos[`/src/assets/images/logos/${logoCategory}/${logoDesc}/${logoName}`]
      ?.default || ''
  );
}

export type IconCategory = 'functions' | 'technologies' | 'tools';

export function resolveIcon(
  category: IconCategory,
  name: string,
  color: string,
): string {
  return getIcon(`${name}_ico-${color}.svg`, category, name);
}
